export enum PocketsDateType {
  OrderDate = 0,
  RequestedDeliveryDate = 1,
  ConfirmedDeliveryDate = 2,
  EstimatedDeliveryDate = 3,
  ShippingDate = 4,
}
